import React from 'react';

import '../Button/ConfirmBrandButton.less';

const ConfirmBrandButton = ({
    translations,
    brandImage,
    flagImage,
    language,
    domain,
    currencies,
    supportedCurrencyCount,
    confirmBrand,
    buttonId,
    enableButton,
    isSingleBrandPPMtoIPM
}) => {

    const isSingleBrandMultiCurrency = isSingleBrandPPMtoIPM &&
                                        supportedCurrencyCount &&
                                        supportedCurrencyCount > 1;


    let buttonClasses = 'confirm-brand-button language-currency-mismatch';
    if (isSingleBrandMultiCurrency) {
        buttonClasses += ' single-brand-multi-currency';
    }

    return (
        <button
            className={buttonClasses}
            type="submit"
            id={buttonId}
            onClick={confirmBrand}
            disabled={!enableButton}
        >
            <div className="brand-section">
                <img className="brand-logo" src={brandImage} />
                <div className="domain">{domain}</div>
            </div>
            <div className="vertical-divider"/>

            <div className={`language-selection ${isSingleBrandMultiCurrency ? 'single-brand-multi-currency' : ''}`}>
                <span className="language-label">{translations['ipmob.confirm_brand.language_label']}</span>
                <div className="language-content">
                    <img className="language-flag" src={flagImage}/>
                    <span className="language-text">{language}</span>
                </div>
            </div>

            {isSingleBrandMultiCurrency ? (null) : (
                <div className="currency-section">
                    <span className="currency-label">{translations['ipmob.confirm_brand.currency_label']}</span>
                    <span className="currency-text">{currencies}</span>
                </div>
            )}
        </button>
    );
}

export default ConfirmBrandButton;
